import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { STORE_PAYMENT_MODAL_TYPE } from '../../const';
import PaymentApi from '../../service/Api/paymentApi';
import { getUserPlan } from './authSlice';
import { getSubscriptionPlan, setSubscriptionPlan } from './paymentsSlice';

const initialState = {
    showPaymentModal: false,
    modalType: '',
    loading: false,
    error: null
};

export const getPaymentModalState = (state) => state.modals.showPaymentModal;
export const getPaymentModalData = (state) => state.modals.modalData;
export const getPaymentModalType = (state) => state.modals.modalType;
export const getPaymentModalDataLoading = (state) => state.modals.loading;

export const tryToCreateOffer = createAsyncThunk('payment/getOffer', async (params, { rejectedWithValue, getState, dispatch }) => {
    try {
        const state = getState();
        const plan = getSubscriptionPlan(state);
        const userPlan = getUserPlan(state);
        if (userPlan.isFree && !plan.isOffer) {
            const data = await PaymentApi.createOfferForUserByPlan(plan.id);
            dispatch(setSubscriptionPlan({ isOffer: true, basePrice: data.data.data.plan.basePrice, price: data.data.data.plan.price }));
        }
        dispatch(setShowPaymentModal(true));
    } catch (error) {
        return rejectedWithValue(error);
    }
});

export const tryToCreateOfferRedirect = createAsyncThunk(
    'payment/getOfferAfterRedirect',
    async (params, { rejectedWithValue, getState, dispatch }) => {
        try {
            const state = getState();
            const plan = getSubscriptionPlan(state);
            const userPlan = getUserPlan(state);
            if (userPlan.isFree) {
                const data = await PaymentApi.createOfferForUserByPlan(plan.id);
                dispatch(setPaymentModalType(!userPlan.isTrial ? STORE_PAYMENT_MODAL_TYPE.trial : STORE_PAYMENT_MODAL_TYPE.subscription));
                dispatch(
                    setSubscriptionPlan({ isOffer: true, basePrice: data.data.data.plan.basePrice, price: data.data.data.plan.price })
                );
                if (data.data.data.isCreated) {
                    dispatch(setShowPaymentModal(true));
                }
                return data.data.data;
            }
        } catch (error) {
            return rejectedWithValue(error);
        }
    }
);

const modalsSlice = createSlice({
    name: 'modals',
    initialState,
    reducers: {
        setShowPaymentModal(store, { payload }) {
            store.showPaymentModal = payload;
        },
        setPaymentModalType(store, { payload }) {
            store.modalType = payload;
        }
    },
    extraReducers(builder) {
        builder
            .addCase(tryToCreateOffer.pending, (store) => {
                store.loading = true;
            })
            .addCase(tryToCreateOffer.fulfilled, (store) => {
                store.loading = false;
            })
            .addCase(tryToCreateOffer.rejected, (store, { payload }) => {
                store.showPaymentModal = false;
                store.modalData = initialState.modalData;
                store.error = payload?.error;
                store.loading = false;
            })
            .addCase(tryToCreateOfferRedirect.pending, (store) => {
                store.loading = true;
            })
            .addCase(tryToCreateOfferRedirect.fulfilled, (store) => {
                store.loading = false;
            })
            .addCase(tryToCreateOfferRedirect.rejected, (store, { payload }) => {
                store.showPaymentModal = false;
                store.modalData = initialState.modalData;
                store.error = payload?.error;
                store.loading = false;
            });
    }
});

export const modalsReducer = modalsSlice.reducer;

export const { setShowPaymentModal, setPaymentModalType } = modalsSlice.actions;
